import { logUsage } from 'owa-analytics';
import { isClientOptingReact } from '../utils/owaOptinUtility';
import updateLightningOperation from 'owa-service/lib/operation/updateLightningOperation';
import { getCookie, updateCookie } from '../utils/browserCookieWrapper';
import logDatapointOperation from 'owa-service/lib/operation/logDatapointOperation';
import DatapointConsumer from 'owa-service/lib/contract/DatapointConsumer';

const MAIL_OPT_IN_LIGHTNING_ID: number = 69;
const CAL_RE_OPT_IN_LIGHTNING_ID = 75;
const LIGHTNING_COMMAND: number = 1;
const REOPTINCLK_COOKIE_NAME: string = 'ReOptInClk';
const CALREOPTINCLK_COOKIE_NAME: string = 'CalReOptInClk';

export default function cleanupOptInCallout() {
    if (isClientOptingReact()) {
        let cookieId = 0;

        if (cleanupOptIn(MAIL_OPT_IN_LIGHTNING_ID, REOPTINCLK_COOKIE_NAME)) {
            cookieId = MAIL_OPT_IN_LIGHTNING_ID;
        }
        if (cleanupOptIn(CAL_RE_OPT_IN_LIGHTNING_ID, CALREOPTINCLK_COOKIE_NAME)) {
            cookieId = CAL_RE_OPT_IN_LIGHTNING_ID;
        }

        logUsage('cleanupOptInCallout', [cookieId]);
    }
}

function cleanupOptIn(lightningId: number, cookieName: string): boolean {
    const reOptInClkCookie = getCookie(cookieName);

    let hasCookie = false;
    // Send optics for the click of TryIt button
    if (reOptInClkCookie) {
        hasCookie = true;
        logDatapointOperation({
            datapoints: [
                {
                    Id: 'PerfTraceCTQ',
                    Consumers: DatapointConsumer.Analytics,
                    Time: new Date(Date.now()).toISOString(),
                    Keys: ['S', 'cd'],
                    Values: ['lightningPeekMore', `id_${lightningId}|category_4`],
                },
            ],
        });

        // Cleanup the cookie
        updateCookie(cookieName);
    }

    // Remove client re-optin callout
    updateLightningOperation(<any>{
        Identities: [lightningId],
        Command: LIGHTNING_COMMAND,
    });

    return hasCookie;
}
